import { ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation } from "@angular/core";
import { LayoutWidget } from "../../layouts/se.layout.widget.abstract";
import { Layouts } from "../../layouts/se.layouts";
import { SeOrgDetailsStore } from "../se.org.details.store";
import { SeOrgSecurityStore } from "../../se.org.security.store";
import { SeAboutOrgComponent } from "../se.about.org.component";

@Component({
    standalone: true,
    selector: "s25-ng-se-org-about-widget",
    template: `
        @if (orgStore.orgDetails()) {
            <se-about-org
                [orgId]="orgStore.orgId()!"
                [mission]="orgStore.mission()"
                [imageAttr]="orgStore.imageAttr()"
                [orgRating]="orgStore.orgRating()"
                [isEditable]="isEditable()"
            />
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated,
    imports: [SeAboutOrgComponent],
})
export class SeOrgAboutWidgetComponent extends LayoutWidget<typeof SeOrgAboutWidgetComponent> {
    static readonly META = {
        name: "About / Mission",
        info: "Displays the organization image, mission statement, and rating.",
        settings: [],
        defaultSettings: {},
    } as const satisfies Layouts.WidgetStatic;

    protected readonly orgStore = inject(SeOrgDetailsStore);
    private readonly orgSecStore = inject(SeOrgSecurityStore);

    protected readonly isEditable = computed(() => this.orgSecStore.canEditOrg() && this.orgStore.editMode());
}
